import update from 'immutability-helper';

const addChoiceReusableMode = (answerChoices, draggableChoiceId, dropZoneId, sourceDropZoneId) => {
  const newAnswers = {};

  // If dragging from a specific drop zone, remove only from that zone
  if (sourceDropZoneId) {
    const sourceAnswers = answerChoices[sourceDropZoneId] || [];
    newAnswers[sourceDropZoneId] = sourceAnswers.filter(choice => choice !== draggableChoiceId);
  }

  // Add to target drop zone (only allow one copy per zone)
  const currentAnswers = answerChoices[dropZoneId] || [];
  if (!currentAnswers.includes(draggableChoiceId)) {
    newAnswers[dropZoneId] = [...currentAnswers, draggableChoiceId];
  } else {
    // Choice already exists in this drop zone, don't add duplicate
    newAnswers[dropZoneId] = currentAnswers;
  }

  return newAnswers;
};

const addChoiceOriginalMode = (answerChoices, draggableChoiceId, dropZoneId) => {
  const newAnswers = {};

  // Remove from all zones first (choice can only be in one zone at a time)
  Object.keys(answerChoices).forEach((key) => {
    newAnswers[key] = answerChoices[key].filter(choice => choice !== draggableChoiceId);
  });

  // Add to target drop zone using Set to prevent duplicates in same zone
  const answersForDropZone = new Set(answerChoices[dropZoneId]).add(draggableChoiceId);
  newAnswers[dropZoneId] = Array.from(answersForDropZone);

  return newAnswers;
};

const addAnswerChoice = (answerChoices, action) => {
  const { draggableChoiceId, dropZoneId, sourceDropZoneId, hasReusableAnswerChoices } = action.payload;

  const newAnswers = hasReusableAnswerChoices
    ? addChoiceReusableMode(answerChoices, draggableChoiceId, dropZoneId, sourceDropZoneId)
    : addChoiceOriginalMode(answerChoices, draggableChoiceId, dropZoneId);

  return update(answerChoices, {
    $merge: newAnswers,
  });
};

const initializeFromDb = (answerChoices, action) => (
  update(answerChoices, {
    $merge: action.payload,
  })
);

const removeAnswerChoice = (answerChoices, action) => {
  const { draggableChoiceId, sourceDropZoneId, hasReusableAnswerChoices } = action.payload;

  const newAnswers = {};

  if (hasReusableAnswerChoices) {
    if (sourceDropZoneId) {
      // Remove only from the specified drop zone
      const sourceAnswers = answerChoices[sourceDropZoneId] || [];
      newAnswers[sourceDropZoneId] = sourceAnswers.filter(choice => choice !== draggableChoiceId);
    }
    // If sourceDropZoneId is null, item came from bank - don't remove anything
  } else {
    // Remove from all zones (original behavior, also needed for the clear button)
    Object.keys(answerChoices).forEach((key) => {
      newAnswers[key] = answerChoices[key].filter(choice => choice !== draggableChoiceId);
    });
  }

  return update(answerChoices, {
    $merge: newAnswers,
  });
};

const answerChoiceReducer = (answerChoices, action) => {
  switch (action.type) {
    case 'ADD':
      return addAnswerChoice(answerChoices, action);
    case 'REMOVE':
      return removeAnswerChoice(answerChoices, action);
    case 'INITIALIZE_FROM_DB':
      return initializeFromDb(answerChoices, action);
    default:
      return answerChoices;
  }
};

export default answerChoiceReducer;
